export default function /* @ngInject */ stripeCheckout(stripeConfig, stripeCreateToken, stripeData) {
    let fields = {};

    function getCardData() {
        let data = {};
        for (let i = 0, m = stripeConfig.fields.length; i < m; i++) {
            let name = stripeConfig.fields[i];
            if (fields[name]) {
                data[name] = fields[name].$modelValue;
            }
        }
        return data;
    }

    function runRemoteCheck() {
        let promise = stripeCreateToken(getCardData()).promise;
        promise.then(storeToken);
        promise.catch(reportRemoteErrors);
        return promise;
    }

    function storeToken(token) {
        stripeData.token = token;
    }

    function reportRemoteErrors(error) {
        let field = fields[error.param];
        if (field) {
            field.$setValidity(error.code, false);
            // Reset validity when model value changes:
            field.$viewChangeListeners.push(() => {
                field.$setValidity(error.code, true);
                field.$viewChangeListeners.pop();
            });
        } else {
            stripeConfig.reportNonFieldError(error.message);
        }
    }

    return {
        fields: fields,
        runRemoteCheck: runRemoteCheck
    };
}



// WEBPACK FOOTER //
// ./stripe/services/stripe-checkout.js